import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./index";
import Dimension from "./Dimension";
import Evaluacion from "./Evaluacion";
import { colores } from "./general";

export default function Estado3dim({ lado }) {
  let { firebase } = useContext(AppContext);
  let activo = firebase.proyectoActivo.proyecto;
  let color = colores["semaforo"];

  const [filtroEvaluacion, setFiltroEvaluacion] = useState("Alcance");

  useEffect(() => {
    // inicializacion de datos para el canvas del proyecto
    let l = lado; // largo del lado del triangulo
    let x1 = (l * 1.85) / 2; // posicion x del vertice superior
    let y1 = l * 0.05; // posicion y del vertice superior
    var c = document.getElementById("estado3dim");
    var ctx = c.getContext("2d");
    // triangulo
    ctx.beginPath();
    ctx.lineWidth = 5;
    ctx.moveTo(x1, y1);
    let y2 = y1 + l * Math.cos(Math.PI / 6);
    ctx.lineTo(x1 + l / 2, y2);
    ctx.lineTo(x1 - l / 2, y2);
    ctx.closePath();
    ctx.fillStyle = color[activo.estado.semaforo];
    ctx.fill();
    // posicion etiquetas
    ctx.font = "2.7vh Arial";
    let w = ctx.measureText("Cronograma").width + 35;
    document.getElementById("Alcance").style.top = ((y2 - y1) / 2 + y1 - 20).toString() + "px";
    document.getElementById("Alcance").style.left = (x1 - l / 2 - 20).toString() + "px";
    document.getElementById("Alcance").style.width = `${w}px`;
    document.getElementById("Cronograma").style.top = ((y2 - y1) / 2 + y1 - 20).toString() + "px";
    document.getElementById("Cronograma").style.left = (x1 + l / 2 - w / 2 - 50).toString() + "px";
    document.getElementById("Cronograma").style.width = `${w}px`;
    document.getElementById("Recursos").style.top = (y2 - 12).toString() + "px";
    document.getElementById("Recursos").style.left = (x1 - w / 2).toString() + "px";
    document.getElementById("Recursos").style.width = `${w}px`;
  });

  function reducir(elemento) {
    document.getElementById("estadoE3d").style.transition = " transform 0.2s";
    document.getElementById("estadoE3d").style.transform = "scale(0.14)";
    setPanelVisible(elemento);
  }
  function ampliar(e) {
    document.getElementById("estadoE3d").style.transition = " transform 0.2s";
    document.getElementById("estadoE3d").style.transform = "";
    setFiltroEvaluacion(filtroEvaluacion === "Alcance" ? "Cronograma" : "Alcance"); // cualquiera.... para hacer refresh..
    setPanelVisible();
  }
  function setPanelVisible(elemento) {
    document.getElementById("dimensionE3d").style.zIndex = -5;
    if (elemento) {
      document.getElementById(elemento).style.zIndex = 1;
      document.getElementById(elemento).style.background = "white";
    }
  }

  return (
    <div style={Se3d}>
      <div id="estadoE3d" style={Sestado3dim}>
        <div style={Scanvas}>
          <canvas id="estado3dim" height={lado * 1.25} width={lado * 1.5}></canvas>
        </div>
        <div style={Setiquetas}>
          <Dimension
            id="Alcance"
            reducir={() => reducir("dimensionE3d")}
            color={color[activo.estado.alcance]}
            rotate="rotateZ(-60deg)"
            set={setFiltroEvaluacion}
          />
          <Dimension
            id="Cronograma"
            reducir={() => reducir("dimensionE3d")}
            color={color[activo.estado.cronograma]}
            rotate="rotateZ(60deg)"
            set={setFiltroEvaluacion}
          />
          <Dimension
            id="Recursos"
            reducir={() => reducir("dimensionE3d")}
            color={color[activo.estado.recursos]}
            rotate=""
            set={setFiltroEvaluacion}
          />
        </div>
      </div>
      <div id="dimensionE3d" style={Sdetalle}>
        <Evaluacion filtro={filtroEvaluacion} click={ampliar} />
      </div>
    </div>
  );
}

const Se3d = {
  position: "relative",
  opacity: 1,
};

const Sestado3dim = {
  position: "absolute",
};

const Scanvas = {
  position: "absolute",
  margin: "auto",
};

const Setiquetas = {
  position: "absolute",
  top: "0px",
  left: "0px",
  zIndex: 4,
};

const Sdetalle = {
  position: "absolute",
  top: "5.5vh",
  width: "100%",
  zIndex: -5,
};

